// src/config/env.js
/* eslint-disable import/no-anonymous-default-export */

const RAW_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT || "https://api.tfrc.app";

const ensureProtocol = (u) =>
  /^https?:\/\//i.test(u) ? u : `http://${u}`;

const API_ENDPOINT = ensureProtocol(RAW_ENDPOINT);

export default {
  api: API_ENDPOINT,
  version: "1.0.0",
};
